import { render } from "./ClinicMutiraoTab.vue?vue&type=template&id=fc232baa&scoped=true"
import script from "./ClinicMutiraoTab.vue?vue&type=script&lang=js"
export * from "./ClinicMutiraoTab.vue?vue&type=script&lang=js"

import "./ClinicMutiraoTab.vue?vue&type=style&index=0&id=fc232baa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc232baa"]])

export default __exports__